/**
 * Warm graha palette — the single source of truth for graha identity color on
 * the parchment ("kg-warm") surfaces: Planetary Positions cards and the Daily
 * Pañcāṅga "Graha Sthāna" glance list. These hues are tuned for the light/warm
 * background and are intentionally muted; the dark Kāla Chakra wheel uses its
 * own brighter palette (PLANET_COLORS in alignmentUtils.ts) tuned for navy.
 *
 * Keyed by canonical English graha name. `grahaWarmColor` normalizes any
 * casing (e.g. the lowercase keys used by the Daily list).
 */
export const GRAHA_WARM_COLORS: Record<string, string> = {
  Sun: '#E0761A',
  Moon: '#8CA0AE',
  Mars: '#C0492E',
  Mercury: '#2E9E5B',
  Jupiter: '#D6A32C',
  Venus: '#C77DA0',
  Saturn: '#5A6577',
  Rahu: '#6B5B95',
  Ketu: '#9C6B3F',
};

/** Fallback for an unknown graha — the muted Moon grey. */
export const GRAHA_WARM_DEFAULT = '#8CA0AE';

/** Look up a graha's warm identity color, tolerant of casing. */
export function grahaWarmColor(name: string | undefined | null): string {
  if (!name) return GRAHA_WARM_DEFAULT;
  const key = name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  return GRAHA_WARM_COLORS[key] || GRAHA_WARM_DEFAULT;
}
